module.exports = __webpack_public_path__ + "static/media/196.7b19780c.jpg";